<template lang="html">

	<section class="mantenimiento row-center" :style="`background:url(${background}) center/cover no-repeat`">
		
		<div class="popup column-center">
			<img :src="logo" class="logo">
			<h2>Para seguir mejorando la calidad de nuestro servicio, estamos trabajando en una nueva plataforma de gestión de prácticas y empleo que se pondrá en funcionamiento a partir del 27 de agosto. </h2>
			<h2>Trabajamos para mejorar, disculpen las molestias.</h2>
		</div>

	</section>

</template>

<script lang="js">

	import {mapGetters,mapActions} from 'vuex';

	export default  {
		name: 'mantenimiento',
		computed:{
			...mapGetters({
				background : 'getBackground',
				logo : 'getLogoColor',
			})
		}

	}
</script>

<style scoped lang="scss">
	.mantenimiento{
		width: 100%;
		min-height: 100vh;
		padding: 20px;
	}

	.popup{
		width: 700px;
		padding: 50px;
		background: white;

		.logo{
			max-width: 200px;
			margin-bottom: 30px;
			display: inline-block;
		}

		h2{
			width: 100%;
			display: inline-block;
			margin-bottom: 10px;
		}
	}

	@media screen and (max-width: 768px){
		.popup h2{
			font-size: 16px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/mantenimiento.vue